// extracted by mini-css-extract-plugin
export default {"button_idp_container":"CustomIdpBranding_button_idp_container__9OlqE","button_idp":"CustomIdpBranding_button_idp__HqXiC"};